module.exports = __webpack_public_path__ + "static/media/素紅糟肉便當.82499980.jpg";